export function handleCalendlyForm() {
    window.open(
      "https://calendly.com/office-stonehengemasonry/30min-1",
      "_blank",
      "noopener,noreferrer"
    );
  };